module.exports = __webpack_public_path__ + "media/images/loading-spinner-5c76b355cdc138491514a769e5e32f39.svg";